import { render, staticRenderFns } from "./JoinUs.vue?vue&type=template&id=3846f3ba&scoped=true&"
var script = {}
import style0 from "./JoinUs.vue?vue&type=style&index=0&id=3846f3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3846f3ba",
  null
  
)

export default component.exports